import { getWindow, isSsr } from './general';

export const getAuthorizationToken = (): string =>
  getWindow()?.THDCustomer?.default?.token ?? '';

export const getSvocId = (): string | null | undefined =>
  getWindow()?.THDCustomer?.default?.svocID;

export const getUserId = (): string | null | undefined =>
  getWindow()?.THDCustomer?.default?.userID;

export const getCustomerType = (): string | null | undefined =>
  getWindow()?.THDCustomer?.default?.customerType;

export const isB2BUser = (): boolean | null | undefined =>
  getWindow()?.THDCustomer?.default?.isB2BCustomer;

export const isB2CUser = (): boolean | null | undefined =>
  getWindow()?.THDCustomer?.default?.isB2CCustomer;

export const getMemberId = (): string | null | undefined => {
  if (isSsr) return null;

  const token = getAuthorizationToken();
  const svocId = getSvocId();

  if (token && svocId) return svocId;

  return getWindow()?.THDCustomer?.default?.userID;
};
